import { AnalyticsTypes } from '../../../../../middleware/google-analytics';
import { APPOINTMENT_DETAILS_GA_CATEGORY } from '../../../../pages/AppointmentDetails/constants';
import { ACTION_PREFIX, GaActionText } from '../../constants';

export const CLICK_OBGYN_CHECKBOX = `${ACTION_PREFIX}/CLICK_OBGYN_CHECKBOX`;

export const TRACK_CLICK_OBGYN_CHECKBOX = `${ACTION_PREFIX}/TRACK_CLICK_OBGYN_CHECKBOX`;

export function clickCheckbox(obgynConfirmation) {
    return {
        type: CLICK_OBGYN_CHECKBOX,
        payload: {
            obgynConfirmation,
        },
    };
}

export const trackClickObgynWarning = () => ({
    type: TRACK_CLICK_OBGYN_CHECKBOX,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            category: APPOINTMENT_DETAILS_GA_CATEGORY,
            action: GaActionText.trackClickObgynWarning,
        },
    },
});
